// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1U0aD","head":"Table_head__1RfnQ","col":"Table_col__2ZQfg"};